import Vue from 'vue';
import Spinner from 'vue-simple-spinner';
import { GlobalState } from '../global-state/global-state';
import { addToCart } from '../utils/add-to-cart';
import {
  setGTMdataLayerEvents,
  setProductAbsorbencyDropRating,
} from '../utils/helpers';

import { showCartSideDraw } from '../sections/cart-drawer';
import { updateAddToCartButtonText } from '../utils/add-to-cart/update-button-text';
import { resetAddToCartButtonText } from '../utils/add-to-cart/reset-button-text';

export default () => {
  if ($('#comparePage').length > 0) {
    new Vue({
      el: '#comparePage',
      components: {
        'vue-simple-spinner': Spinner,
      },
      data: {
        sharedState: GlobalState.state,
        loading: true,
        compareList: [],
        comparisonProductsData: [],
        sampleThresholdReached: false,
        displayErrors: false,
      },
      created() {
        this.compareList = GlobalState.getCompareList(this);
      },
      beforeMount() {
        this.compareList.forEach((element, index) => {
          const productIsInSampleCart = (product) => product === element.handle;
          const inSampleCart = this.sharedState.sampleCartHandles.some(
            productIsInSampleCart
          );
          this.getProducts.apply(this, [element.handle, inSampleCart]);

          /**
           * Update the Disabled State if Request Samples
           * If greater than or equal to 3
           */
          if (this.sharedState.sampleCartHandles.length >= 3) {
            this.sampleThresholdReached = true;
          }

          /**
           * Update Global State
           */
          GlobalState.setNumberOfCompareProducts(this, index + 1);
          GlobalState.setNumberOfSamples(this, this.sampleCartHandles.length);
        });
      },
      mounted() {
        setTimeout(() => {
          this.loading = false;
        }, 800);
      },
      methods: {
        getProducts: function (productHandle, inSampleCart) {
          const self = this;
          $.getJSON(`/products/${productHandle}.js`, function (product) {
            const disabledForProductSampling = product.tags.includes(
              'disable_product_samples'
            );
            const disabledForQuickshop =
              product.tags.includes('disable_quickshop');

            product['inSampleCart'] = inSampleCart;

            let newProductObject = {
              ...product,
              short_description: self.stripProductDescription(
                product.description,
                150
              ),
              disabledForProductSampling: disabledForProductSampling,
              disabledForQuickshop: disabledForQuickshop,
            };
            self.comparisonProductsData.push(newProductObject);
          });
        },

        addToCart: function (index) {
          const QUANTITY = 1;
          const RESET_DELAY = 3000;
          const product = this.comparisonProductsData[index];
          const selectedVariantID = product.variants[0].id;
          const productHandle = product.handle;
          const callback = {
            success: () => {
              showCartSideDraw();
              updateAddToCartButtonText(index);
              setInterval(() => resetAddToCartButtonText(index), RESET_DELAY);
            },
          };
          addToCart({
            quantity: QUANTITY,
            productHandle,
            selectedVariantID,
            callback
          });
        },

        toggleItemInSampleCart: function (event, product, itemIndex) {
          let alreadyInArray = false;
          let alreadyInArrayIndex = false;
          const GlobalStateSampleCartArray = GlobalState.getSampleCart(this);

          this.sampleCartHandles.forEach((item, index) => {
            if (item === product.handle) {
              alreadyInArray = true;
              alreadyInArrayIndex = index;
            }
          });

          if (this.sampleCartHandles.length < 3) {
            if (alreadyInArray) {
              GlobalStateSampleCartArray.splice(alreadyInArrayIndex, 1);
              this.comparisonProductsData[itemIndex]['inSampleCart'] = false;
            } else {
              GlobalStateSampleCartArray.push(product.handle);
              this.comparisonProductsData[itemIndex]['inSampleCart'] = true;
            }

            event.currentTarget.parentElement.classList.toggle(
              'compare-page__item-sample--in-cart'
            );

            // Set GTM Data Layer
            let gtmSampleProduct = this.comparisonProductsData
              .map((item) => item.title)
              .filter((item) => item === product.title);

            setGTMdataLayerEvents(
              'sample-add',
              gtmSampleProduct,
              'Compare Page'
            );
          } else if (
            this.sampleCartHandles.length >= 3 &&
            !this.comparisonProductsData[itemIndex]['inSampleCart']
          ) {
            this.displayThresholdErrorMessage();
          } else {
            event.target.checked = false;
            // Update the UI
            if (
              event.currentTarget.parentElement.classList.contains(
                'compare-page__item-sample--in-cart'
              )
            ) {
              event.currentTarget.parentElement.classList.remove(
                'compare-page__item-sample--in-cart'
              );
            }
            // Update the Array
            if (alreadyInArray) {
              GlobalStateSampleCartArray.splice(alreadyInArrayIndex, 1); // Global State
              this.comparisonProductsData[itemIndex]['inSampleCart'] = false;
            }
          }

          // Update Global State
          if (this.sampleCartHandles.length <= 3) {
            GlobalState.setSampleCartHandles(
              this,
              JSON.stringify([product.handle])
            );
            GlobalState.setNumberOfSamples(this, this.sampleCartHandles.length);
          }
        },

        stripProductDescription: function (description, characters) {
          // Strip HTML Tags
          description = description.replace(/<[^>]+>/g, '');

          // Check Length of String
          if (description.length <= characters) {
            return description;
          }
          return description.slice(0, characters) + '...';
        },

        removeCompareItem: function (index) {
          this.comparisonProductsData.splice(index, 1);

          // Update Global, then update Local state
          this.compareList.splice(index, 1);
          GlobalState.setCompareList(this, this.compareList);
        },

        renderDropletRating: function (tags) {
          return setProductAbsorbencyDropRating(tags);
        },

        renderProductQtySize: function (product) {
          let qty = '';
          let options = product.options;

          // Check product has the Option variant
          for (let $i = 0; $i < options.length; $i++) {
            // Spread Data because Vue Returns an Observable
            const option = { ...options[$i] };
            let name = option.name;
            let position = option.position;
            let value = option.values;
            if (name == 'Qty') {
              qty = value[0];
            }
          }
          return qty;
        },

        checkSampleThreshold: function (event, ItemIndex) {
          if (
            this.sharedState.sampleCartHandles.length >= 3 &&
            !this.comparisonProductsData[ItemIndex]['inSampleCart']
          ) {
            event.stopPropagation();
            event.preventDefault();
            this.displayThresholdErrorMessage();
          }
        },

        displayThresholdErrorMessage: function () {
          this.displayErrors = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setTimeout(() => {
            this.displayErrors = false;
          }, 3000);
        },
      },
      computed: {
        sampleCartHandles: function () {
          if (this.sharedState.sampleCartHandles.length >= 3) {
            this.sampleThresholdReached = true;
          } else {
            this.sampleThresholdReached = false;
          }
          return this.sharedState.sampleCartHandles;
        },
      },
    });
  }
};
